import { styled } from '@mui/material';
import { LedgerContext } from '../../context';

const PREFIX = 'LedgerTable';

export const classes = {
  row: `${PREFIX}-row`,
};

export const StyledLedgerContextProvider = styled(LedgerContext.Provider)(() => ({
  [`& .${classes.row}`]: {
    '&:hover .delete-button': {
      opacity: 1,
    },
  },
}));